'use client';

import { motion } from 'framer-motion';

import { Image } from '@/components/client';

interface EventCardProps {
  event: {
    id: number;
    badge: string;
    image: string;
  };
}

const CARD_ANIMATION = {
  hidden: {
    opacity: 0,
    y: 50,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

export const EventCard = ({ event }: EventCardProps) => {
  const { image, badge } = event;

  return (
    <motion.li
      variants={CARD_ANIMATION}
      className="relative flex aspect-square size-full shrink-0 flex-col items-center justify-center gap-12 rounded-pill bg-Gray-white p-40"
    >
      <div className="flex aspect-square w-full max-w-160 items-center justify-center md:max-w-210">
        <Image
          alt={`이벤트 ${event.id} 이미지`}
          className="size-full object-contain"
          width={134 * 3}
          height={170 * 3}
          src={image}
        />
      </div>
      <p className="absolute right-4 top-4 flex size-72 items-center justify-center rounded-pill bg-Gray-black font-700 text-Gray-white typo-body3 md:right-20 md:top-20">
        {badge}
      </p>
    </motion.li>
  );
};
